import { moduleState, state } from 'cerebral'
import { crudActions } from '../factories'
import { DateTime } from 'luxon'
import { uniq } from 'ramda'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'serviceRequests' })

export const syncPendingRequests = async ({ serviceRequestsService: service, store }) => {
  const { data: pendingRequests = [] } = await service.find({ filter: 'pending' })
  store.set(moduleState`pendingRequests`, pendingRequests)
  return { pendingRequests }
}

export const acknowledgeServiceRequest = async ({ props: { id }, serviceRequestsService: service }) => {
  const serviceRequest = await service.patch(id, { status: 'acknowledged', acknowledgedAt: new Date() })
  return { entities: { serviceRequests: [serviceRequest] } }
}

export const dismissServiceRequest = async ({ props: { id, minutes = 5 }, serviceRequestsService: service }) => {
  const dismissedUntil = DateTime.utc().plus({ minutes }).toISO()
  const serviceRequest = await service.patch(id, { status: 'dismissed', dismissedAt: new Date(), dismissedUntil })
  return { entities: { serviceRequests: [serviceRequest] } }
}

export const addItemToList = async ({ props: { serviceRequest = {} }, get, serviceRequestsValidation }) => {
  const list = get(state`serviceRequests.list`)
  const route = get(state`route`)

  serviceRequest = serviceRequestsValidation.cast(serviceRequest)

  const currentStatus = route.params.filter || 'pending'
  let ids = list.ids

  if (serviceRequest && serviceRequest.status === currentStatus) {
    ids = uniq([...list.ids, serviceRequest._id])
  } else if (list.ids.includes(serviceRequest._id)) {
    ids = list.ids.filter((id) => id !== serviceRequest._id)
  }

  return { result: { ids }, entities: { serviceRequests: [serviceRequest] } }
}
